module.exports = __webpack_public_path__ + "static/banner-texture-new-4-e0b2de9f085201911ac61aedafe74e19.png";